<template>
  <v-layout column>
    <v-card
      light
      :color="vcardColor"
      class="endpoints"
    >
      <v-card-title>
        <div :style="vcardTitleColor">
          <span class="black--text">
            <v-icon
              v-if="hasUnresolvedEvent"
              large
              style="animation: pulse-red 1s infinite;"
            >warning
            </v-icon>
            <strong> {{ endpoint.label }} </strong></span><br>
          <span class="blue--dark-grey subheading">{{ endpoint.ms_link_number }}</span><br>
        </div>
      </v-card-title>
      <v-card-text>
        <span v-if="endpoint.device !== null">
          <p>{{ endpoint.device.label }}</p>
          <v-layout row>
            <v-flex>
              <v-btn
                v-if="endpoint.device.element_id"
                small
                :href="elementLinkCharts"
                target="_blank"
              >
                <v-icon small>bar_chart</v-icon>&nbsp;Charts
              </v-btn>
              &nbsp;
              <v-btn
                v-if="endpoint.device.element_id"
                small
                :href="elementLinkReading"
                target="_blank"
              >
                <v-icon small>table_chart</v-icon>&nbsp;Messwerte
              </v-btn>
              &nbsp;
              <v-btn small @click="toggleThresholds = !toggleThresholds">
                <v-icon small>visibility</v-icon>&nbsp;Schwellwerte
              </v-btn>
                &nbsp;
              <v-btn
                v-if="hasReadings"
                small
                @click="toggleReading = !toggleReading"
              >
                <v-icon small>visibility</v-icon>&nbsp;Messwerte ({{ updatedAt }})
              </v-btn>
              &nbsp;
              <v-btn
                v-if="!hasReadings"
                small
                disabled
              >
                <v-icon small>error_outline</v-icon>&nbsp;Keine Daten ({{ updatedAt }})
              </v-btn>
            </v-flex>
          </v-layout>

          <ul v-if="!toggleReading" class="mb-4 readings">
            <li v-for="(reading, label) in readings" :key="label">
              {{ readingFormatted(label, reading) }}
            </li>
          </ul>

          <p v-if="!toggleThresholds" class="thresholds">
            Schwellwerte / Spannung
            <ul class="mb-4">
              <li class="indicate_warning">
                Obergrenze: {{ endpoint.device.threshold_u_max_warn }} V
              </li>
              <li class="indicate_critical">
                Obergrenze: {{ endpoint.device.threshold_u_max_crit }} V
              </li>
              <li class="indicate_warning">
                Untergrenze: {{ endpoint.device.threshold_u_min_warn }} V
              </li>
              <li class="indicate_critical">
                Untergrenze: {{ endpoint.device.threshold_u_min_crit }} V
              </li>
            </ul>
            Schwellwerte / Strom
            <ul>
              <li class="indicate_warning">
                Obergrenze: {{ endpoint.device.threshold_i_max_warn }} A
              </li>
              <li class="indicate_critical">
                Obergrenze:{{ endpoint.device.threshold_i_max_crit }} A
              </li>
              <li class="indicate_warning">
                Untergrenze: {{ endpoint.device.threshold_i_min_warn }} A
              </li>
              <li class="indicate_critical">
                Untergrenze: {{ endpoint.device.threshold_i_min_warn }} A für 60s.
              </li>
            </ul>
          </p>
        </span>
        <span v-else>
          <p>Kein verbundener Sensor.</p>
        </span>
        <stats :endpoint="endpoint" />
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import _ from 'lodash';
import Stats from './Stats.vue';

export default {
  name: 'Kabelverteiler',
  components: {
    Stats,
  },
  props: {
    endpoint: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      toggleReading: true,
      toggleThresholds: true,
    };
  },
  computed: {
    vcardTitleColor() {
      return this.endpoint.color_code;
    },
    vcardColor() {
      if (this.hasWarning) {
        return 'orange';
      }
      if (this.hasCritical) {
        return 'red';
      }
      return this.endpoint.color_code;
    },
    updatedAt() {
      return this.$moment(this.endpoint.device.updated_at).format('DD.MM.YYYY HH:mm:ss');
    },
    hasReadings() {
      const onlyAffected = _.pickBy(this.endpoint.device.last_readings, (value, key) => {
        if (Object.values(this.endpoint.affected_values).indexOf(key) > -1) {
          return true;
        }
        return false;
      });
      const read = _.pickBy(onlyAffected, _.isNumber);
      return Object.keys(read).length;
    },
    readings() {
      // only return reading in list of endpoints affected_values
      const onlyAffected = _.pickBy(this.endpoint.device.last_readings, (value, key) => {
        if (Object.values(this.endpoint.affected_values).indexOf(key) > -1) {
          return true;
        }
        return false;
      });
      this.endpointReadings = onlyAffected;
      return _.pickBy(onlyAffected, _.isNumber);
    },
    hasUnresolvedEvent() {
      if (this.endpoint.events.length > 0) {
        return _.find(this.endpoint.events, (o) => { return o.resolved === false; });
      }
      return false;
    },
    hasWarning() {
      if (this.endpoint.events.length > 0) {
        return _.find(this.endpoint.events, (o) => { return o.resolved === false && o.severity === 'warning'; });
      }
      return false;
    },
    hasCritical() {
      if (this.endpoint.events.length > 0) {
        return _.find(this.endpoint.events, (o) => { return o.resolved === false && o.severity === 'critical'; });
      }
      return false;
    },
    elementLinkReading() {
      return `${this.getBaseUrl}/${this.endpoint.device.mandate}/tree/d:${this.endpoint.device.element_id}/readings/list`;
    },
    elementLinkCharts() {
      return `${this.getBaseUrl}/${this.endpoint.device.mandate}/tree/d:${this.endpoint.device.element_id}/readings/graph`;
    },
    getBaseUrl() {
      return this.$store.state.variables.environment[this.endpoint.device.env];
    },
  },
  methods: {
    readingFormatted(key, value) {
      let unit = '';
      if (key.toUpperCase().charAt(0) === 'U') {
        unit = 'V';
      }
      if (key.toUpperCase().charAt(0) === 'I') {
        unit = 'A';
      }
      return `${key.toUpperCase()}: ${value.toFixed(2)} ${unit}`;
    },
  },
};
</script>

<style scoped>
.indicate_warning {
  color: orange;
}
.indicate_critical {
  color: red;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.endpoints {
  padding: 10px;
  margin: 5px;
  opacity: 0.9;
}
.thresholds {
  background: white;
  border: 2px dotted #dfdfdf;
  padding:5px;
}
.readings {
  background: white;
  border: 2px dotted #dfdfdf;
  padding:5px;
}
</style>
